// dashboards-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "% da pista identificado pelo app — em litros e em nº de abastecimentos": "% de la playa identificado por la aplicación — en litros y en n.º de cargas",
    "% do faturamento": "% de la facturación",
    ") · Expirados": ") · Expirados",
    ". Essa parte é estimativa, não receita certa.": ". Esa parte es una estimación, no ingreso garantizado.",
    "/mês)": "/mes)",
    "/ponto como base — configure o cashback por ponto para o valor real.": "/punto como base — configure el cashback por punto para el valor real.",
    "1ª fatura": "1.ª factura",
    ": média": ": promedio",
    "Abastecimentos na janela": "Cargas en la ventana",
    "Acesso não autorizado.": "Acceso no autorizado.",
    "Alguns minutos na primeira vez.": "Algunos minutos la primera vez.",
    "Ativos": "Activos",
    "Ativos no período": "Activos en el período",
    "Atualizando fidelidade e pontos… isso pode levar alguns instantes.": "Actualizando fidelidad y puntos… esto puede llevar algunos instantes.",
    "Até 1ª fatura": "Hasta 1.ª factura",
    "Até a primeira fatura": "Hasta la primera factura",
    "Até faturar": "Hasta facturar",
    "Até o início do faturamento": "Hasta el inicio de la facturación",
    "Base cadastrada": "Base registrada",
    "Base de clientes": "Base de clientes",
    "Base total:": "Base total:",
    "Base:": "Base:",
    "Buscar rede…": "Buscar red…",
    "Cadastros novos no tempo": "Registros nuevos en el tiempo",
    "Calculando fidelidade e pontos…": "Calculando fidelidad y puntos…",
    "Cancelada em": "Cancelada en",
    "Captura da rede": "Captura de la red",
    "Carregando a carteira…": "Cargando la cartera…",
    "Carregando a rede…": "Cargando la red…",
    "Carteira atualizada": "Cartera actualizada",
    "Carteira de redes": "Cartera de redes",
    "Carteira de redes ranqueada por risco · últimos": "Cartera de redes clasificada por riesgo · últimos",
    "Carência": "Carencia",
    "Clientes ativos": "Clientes activos",
    "Clique na linha para abrir o detalhe da rede": "Haga clic en la fila para abrir el detalle de la red",
    "Comercial e faturamento": "Comercial y facturación",
    "Comissão de revenda": "Comisión de revendedor",
    "Como administrador, escolha uma rede no menu Cadastro → Rede e tente novamente.": "Como administrador, elija una red en el menú Registro → Red e inténtelo de nuevo.",
    "Como funciona": "Cómo funciona",
    "Composição da carteira": "Composición de la cartera",
    "Coorte emitida no período · vermelho = expirado sem uso": "Cohorte emitida en el período · rojo = expirado sin uso",
    "Custo do programa × retorno": "Costo del programa × retorno",
    "Custo total": "Costo total",
    "Dados da pista indisponíveis para esta rede (sem concentrador integrado).": "Datos de la playa no disponibles para esta red (sin concentrador integrado).",
    "Descontos + cashback + cupons vs faturamento identificado": "Descuentos + cashback + cupones vs facturación identificada",
    "Economia de pontos — quanto custa, quanto rende": "Economía de puntos — cuánto cuesta, cuánto rinde",
    "Em risco": "En riesgo",
    "Em risco = sem abastecer há mais de": "En riesgo = sin cargar combustible hace más de",
    "Estimativa usando": "Estimación usando",
    "Evolução do Produto ·": "Evolución del Producto ·",
    "Faturamento identificado": "Facturación identificada",
    "Faturas no período": "Facturas en el período",
    "Fidelidade e pontos atualizados": "Fidelidad y puntos actualizados",
    "Fidelidade, receita e engajamento da sua rede em um só lugar": "Fidelidad, ingresos e interacción de su red en un solo lugar",
    "Fluxo de pontos no período": "Flujo de puntos en el período",
    "Gerados": "Generados",
    "Inadimplência": "Morosidad",
    "Início faturamento": "Inicio facturación",
    "L/ab ·": "L/cg ·",
    "Leitura": "Lectura",
    "Linhas em âmbar são os postos que entraram na receita não capturada.": "Las filas en ámbar son las estaciones que entraron en el ingreso no capturado.",
    "MRR": "MRR",
    "MRR da carteira": "MRR de la cartera",
    "Movimento por hora × dia": "Movimiento por hora × día",
    "Módulos contratados sem uso:": "Módulos contratados sin uso:",
    "Nada emitido no período.": "Nada emitido en el período.",
    "Nenhum cadastro novo no período.": "Ningún registro nuevo en el período.",
    "Nenhum cliente desta rede tem abastecimento registrado.": "Ningún cliente de esta red tiene carga registrada.",
    "Nenhum posto cadastrado nesta rede.": "Ninguna estación registrada en esta red.",
    "Nenhum posto rodando sem fatura": "Ninguna estación funcionando sin factura",
    "Nenhum sinal de risco acionado no período.": "Ninguna señal de riesgo activada en el período.",
    "Nenhuma fatura registrada para esta rede.": "Ninguna factura registrada para esta red.",
    "Nenhuma pendência em aberto para esta rede.": "Ningún pendiente abierto para esta red.",
    "Novos clientes": "Nuevos clientes",
    "Novos no período": "Nuevos en el período",
    "Nunca abasteceram": "Nunca cargaron combustible",
    "Não foi possível atualizar agora, tente de novo.": "No fue posible actualizar ahora, inténtelo de nuevo.",
    "Não foi possível carregar o cabeçalho da rede — as demais seções continuam válidas.": "No fue posible cargar el encabezado de la red — las demás secciones siguen válidas.",
    "Os dados de volume vão até": "Los datos de volumen llegan hasta",
    "Passivo de pontos": "Pasivo de puntos",
    "Penetração": "Penetración",
    "Penetração do app na pista": "Penetración de la aplicación en la playa",
    "Por quantidade usada no período": "Por cantidad usada en el período",
    "Por que esta rede está nesse risco": "Por qué esta red está en ese riesgo",
    "Potencial de upsell": "Potencial de upsell",
    "Potencial declarado — os preços de módulo não entram na cobrança real.": "Potencial declarado — los precios de módulo no entran en el cobro real.",
    "Preparando o passivo de pontos…": "Preparando el pasivo de puntos…",
    "Preparando os dados de fidelidade e pontos pela primeira vez… isso leva alguns minutos.": "Preparando los datos de fidelidad y puntos por primera vez… esto lleva algunos minutos.",
    "Preço declarado": "Precio declarado",
    "Preço mensal": "Precio mensual",
    "Produtos & Resgates": "Productos & Canjes",
    "Pulso do período": "Pulso del período",
    "Quando o posto não tem data de instalação, a contagem parte da data de cadastro.": "Cuando la estación no tiene fecha de instalación, el conteo parte de la fecha de registro.",
    "Recalculando a carteira… os números aparecem assim que terminar.": "Recalculando la cartera… los números aparecen en cuanto termine.",
    "Receita não capturada": "Ingreso no capturado",
    "Receita por R$ 1 investido": "Ingreso por R$ 1 invertido",
    "Receita por abastecimento": "Ingreso por carga",
    "Rede não informada": "Red no informada",
    "Redes ativas": "Redes activas",
    "Redes em risco alto": "Redes en riesgo alto",
    "Resgates no período": "Canjes en el período",
    "Risco": "Riesgo",
    "Saldo acumulado da base = compromisso futuro": "Saldo acumulado de la base = compromiso futuro",
    "Selecione uma rede para ver o Painel 360": "Seleccione una red para ver el Panel 360",
    "Sem faturas vencidas": "Sin facturas vencidas",
    "Sem movimentação de pontos no período.": "Sin movimiento de puntos en el período.",
    "Sem movimento registrado no período.": "Sin movimiento registrado en el período.",
    "Sem produtos resgatados no período.": "Sin productos canjeados en el período.",
    "Sem resgates no período.": "Sin canjes en el período.",
    "Situação das faturas": "Situación de las facturas",
    "Taxa de resgate (emitido → usado)": "Tasa de canje (emitido → usado)",
    "Tempo de implantação": "Tiempo de implementación",
    "Ticket médio da carteira": "Ticket promedio de la cartera",
    "Toda a pista — planeje equipe e promoções nos horários certos": "Toda la playa — planifique equipo y promociones en los horarios correctos",
    "Todo posto com pelo menos": "Toda estación con al menos",
    "Todos os postos foram valorados pelo": "Todas las estaciones fueron valoradas por el",
    "Top produtos resgatados": "Top productos canjeados",
    "Usados": "Usados",
    "Valor por ponto não configurado nesta rede.": "Valor por punto no configurado en esta red.",
    "Voltar para a carteira": "Volver a la cartera",
    "Volume (litros)": "Volumen (litros)",
    "Volume:": "Volumen:",
    "ab.": "cg.",
    "abastecimentos no período tem fatura.": "cargas en el período tiene factura.",
    "abastecimentos no período, carência vencida e sem fatura.": "cargas en el período, carencia vencida y sin factura.",
    "anteriores": "anteriores",
    "antes": "antes",
    "clientes · Faturamento no período:": "clientes · Facturación en el período:",
    "com data)": "con fecha)",
    "com pelo menos": "con al menos",
    "competência": "mes de facturación",
    "destes postos não têm preço mensal cadastrado e": "de estas estaciones no tienen precio mensual registrado y",
    "dias comparados com os": "días comparados con los",
    "dias ·": "días ·",
    "dias.": "días.",
    "em prêmios": "en premios",
    "em resgates potenciais": "en canjes potenciales",
    "emitidos ·": "emitidos ·",
    "entraram": "entraron",
    "estimados": "estimados",
    "fatura": "factura",
    "inativo": "inactivo",
    "inativo = há mais de": "inactivo = hace más de",
    "mín": "mín",
    "módulos em uso": "módulos en uso",
    "novos": "nuevos",
    "parados": "estancados",
    "pela mediana da carteira": "por la mediana de la cartera",
    "por ponto (cashback configurado da rede).": "por punto (cashback configurado de la red).",
    "preço mensal do próprio posto": "precio mensual de la propia estación",
    "pts": "pts",
    "risco de downgrade": "riesgo de downgrade",
    "sem dado de pista": "sin dato de playa",
    "sem fatura": "sin factura",
    "usados": "usados",
    "vencida": "vencida",
    "· Abastecimentos:": "· Cargas:",
    "· Clube": "· Club",
    "· Loja de pontos": "· Tienda de puntos",
    "· Resgatados": "· Canjeados",
    "· a mais antiga venceu em": "· la más antigua venció en",
    "· comparado com o período anterior de mesmo tamanho": "· comparado con el período anterior de mismo tamaño",
    "· comparando com o período anterior": "· comparando con el período anterior",
    "· emitida em": "· emitida en",
    "· máx": "· máx",
    "· p90": "· p90",
    "· vence": "· vence",
    "Última fatura emitida": "Última factura emitida",
    "Último abastecimento da rede:": "Última carga de la red:",
    "— a agregação diária está atrasada. Ticket, abastecimentos e receita podem estar defasados.": "— la agregación diaria está atrasada. Ticket, cargas e ingresos pueden estar desactualizados.",
};

export default catalogo;
